//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VakansiaCard",
  props: {
    card: {
      type: Object,
      default: () => ({})
    }
  },
}
